module.exports = __webpack_public_path__ + "static/img/gohan_japan_logo.26efbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/gohan_japan_logo.png
// module id = eqU7
// module chunks = 0